import activityApi from "../api/activity-api";

const search = async (condition, pagination) => {
	try {
		const result = await activityApi.search(condition, pagination);
        // console.log(result);
		return { list: result.list, pagination: result.paginable };
	} catch (err) {
		console.error(err);
		throw err;
	}
};

const getById = async (payload) => {
    const resp = await activityApi.getById(payload);
    if (resp.status !== "SUCCESS") {
        throw resp.responseMsgTh;
    }
    return resp;
}

const add = async (activity) => {
    const resp = await activityApi.add(activity);
    if (resp.status !== "SUCCESS") {
        throw resp.responseMsgTh;
    }
    return resp;
}

const edit = async (activity) => {
    const resp = await activityApi.edit(activity);
    if (resp.status !== "SUCCESS") {
        throw resp.responseMsgTh;
    }
    return resp;
}

const remove = async (activity) => {
    const resp = await activityApi.remove(activity);
    if (resp.status !== "SUCCESS") {
        throw resp.responseMsgTh;
    }
    return resp;
}

const activityService = {
    search,
    getById,
    add,
    edit,
    remove
};

export default activityService